import "./router/class-component-hooks";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";

import "./assets/scss/reset.scss"; // 引入全局重置样式
import "./assets/scss/resize.scss"; // 引入全局响应式媒体查询样式
import "./assets/scss/font.scss"; // 引入web font
import "./assets/icon/iconfont.css"; // 引入icon

import * as vClickOutside from "v-click-outside-x";

Vue.config.productionTip = false;
Vue.use(vClickOutside);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
